var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_66446",
    "data-name": "Group 66446",
    transform: "translate(48.407 -0.322) rotate(90)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3404",
    "data-name": "Ellipse 3404",
    cx: 24,
    cy: 24,
    r: 24,
    transform: "translate(0.322 0.407)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "arrow-down-sign-to-navigate",
    transform: "translate(27.896 18.316) rotate(90)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_23854",
    "data-name": "Path 23854",
    d: "M6.624,7.552a.925.925,0,0,1-.656-.272l-5.7-5.7A.928.928,0,0,1,1.584.272L6.624,5.313,11.665.272a.928.928,0,1,1,1.312,1.312l-5.7,5.7A.925.925,0,0,1,6.624,7.552Z",
    transform: "translate(0 0)",
    fill: "#244158"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/Arrow.ecf75f821d2173ea6369344891b30a5d.svg";
export { ForwardRef as ReactComponent };